import { defineMessages } from "./define";

export const landingMessages = defineMessages({
  ru: {
    "landing.login": "Войти",
    "landing.signup": "Регистрация",
    "landing.hero_title": "Коллекционируйте цифровые активы уверенно",
    "landing.hero_desc": "Открывайте коллекции, управляйте своими NFT и совершайте сделки в едином прозрачном интерфейсе.",
    "landing.cta_start": "Начать работу",
    "landing.cta_have_account": "У меня есть аккаунт",
    "landing.how_title": "Как это работает",
    "landing.how_step1_title": "Выберите NFT",
    "landing.how_step1_desc": "Просматривайте коллекции по сети, цене и статусу продажи.",
    "landing.how_step2_title": "Пополните баланс",
    "landing.how_step2_desc": "Карта, СБП или криптовалюта — баланс пополняется в несколько кликов.",
    "landing.how_step3_title": "Купите в один клик",
    "landing.how_step3_desc": "Оплата списывается с баланса, NFT сразу появляется в вашем портфеле.",
    "landing.how_step4_title": "Продайте и выведите",
    "landing.how_step4_desc": "Выставите NFT на продажу и выведите средства в течение 24 часов.",
    "landing.guarantees_title": "Гарантии",
    "landing.guarantees_card1_title": "Безопасный баланс",
    "landing.guarantees_card1_desc": "Средства списываются только при подтверждении покупки — ошибочные операции исключены.",
    "landing.guarantees_card2_title": "Прозрачная история",
    "landing.guarantees_card2_desc": "Каждая сделка отображается в истории операций со статусом и датой.",
    "landing.guarantees_card3_title": "Быстрый вывод",
    "landing.guarantees_card3_desc": "Зачисление на баланс сразу после продажи, вывод — от минимальной суммы в течение 24 часов.",
    "landing.guarantees_card4_title": "Двухфакторная защита",
    "landing.guarantees_card4_desc": "Дополнительный код подтверждения для входа и вывода средств.",
    "landing.features_title": "Преимущества",
    "landing.features_card1_title": "Надёжные сценарии",
    "landing.features_card1_desc": "Понятные статусы каждой операции",
    "landing.features_card2_title": "Быстрый доступ",
    "landing.features_card2_desc": "Коллекции и активы без лишних шагов",
    "landing.features_card3_title": "Чистый интерфейс",
    "landing.features_card3_desc": "Данные и действия в центре внимания",
    "landing.eyebrow": "Маркетплейс цифровых активов",
    "landing.auth_nav": "Навигация входа"
  },
  en: {
    "landing.login": "Log in",
    "landing.signup": "Sign up",
    "landing.hero_title": "Collect digital assets with confidence",
    "landing.hero_desc": "Explore collections, manage your NFTs and trade in one transparent interface.",
    "landing.cta_start": "Get started",
    "landing.cta_have_account": "I have an account",
    "landing.how_title": "How it works",
    "landing.how_step1_title": "Choose an NFT",
    "landing.how_step1_desc": "Browse collections by network, price and sale status.",
    "landing.how_step2_title": "Fund your balance",
    "landing.how_step2_desc": "Card, SBP or crypto — top up your balance in a few clicks.",
    "landing.how_step3_title": "Buy in one click",
    "landing.how_step3_desc": "Payment is deducted from your balance and the NFT lands straight in your portfolio.",
    "landing.how_step4_title": "Sell and withdraw",
    "landing.how_step4_desc": "List an NFT for sale and withdraw funds within 24 hours.",
    "landing.guarantees_title": "Guarantees",
    "landing.guarantees_card1_title": "Secure balance",
    "landing.guarantees_card1_desc": "Funds are only deducted once a purchase is confirmed — mistaken charges are impossible.",
    "landing.guarantees_card2_title": "Transparent history",
    "landing.guarantees_card2_desc": "Every trade appears in your operation history with a status and date.",
    "landing.guarantees_card3_title": "Fast withdrawals",
    "landing.guarantees_card3_desc": "Credited to your balance right after a sale; withdrawals from the minimum amount clear within 24 hours.",
    "landing.guarantees_card4_title": "Two-factor protection",
    "landing.guarantees_card4_desc": "An extra confirmation code for sign-in and withdrawals.",
    "landing.features_title": "Highlights",
    "landing.features_card1_title": "Reliable flows",
    "landing.features_card1_desc": "Clear status for every operation",
    "landing.features_card2_title": "Fast access",
    "landing.features_card2_desc": "Collections and assets without extra steps",
    "landing.features_card3_title": "Clean interface",
    "landing.features_card3_desc": "Data and actions front and centre",
    "landing.eyebrow": "Digital assets marketplace",
    "landing.auth_nav": "Sign-in navigation"
  },
  ua: {
    "landing.login": "Увійти",
    "landing.signup": "Реєстрація",
    "landing.hero_title": "Колекціонуйте цифрові активи впевнено",
    "landing.hero_desc": "Відкривайте колекції, керуйте своїми NFT та здійснюйте угоди в єдиному прозорому інтерфейсі.",
    "landing.cta_start": "Почати роботу",
    "landing.cta_have_account": "У мене вже є акаунт",
    "landing.how_title": "Як це працює",
    "landing.how_step1_title": "Виберіть NFT",
    "landing.how_step1_desc": "Переглядайте колекції за мережею, ціною та статусом продажу.",
    "landing.how_step2_title": "Поповніть баланс",
    "landing.how_step2_desc": "Картка, СБП або криптовалюта — баланс поповнюється за кілька кліків.",
    "landing.how_step3_title": "Купуйте в один клік",
    "landing.how_step3_desc": "Оплата списується з балансу, NFT одразу з'являється у вашому портфелі.",
    "landing.how_step4_title": "Продайте і виведіть",
    "landing.how_step4_desc": "Виставте NFT на продаж і виведіть кошти протягом 24 годин.",
    "landing.guarantees_title": "Гарантії",
    "landing.guarantees_card1_title": "Безпечний баланс",
    "landing.guarantees_card1_desc": "Кошти списуються лише після підтвердження покупки — помилкові операції виключені.",
    "landing.guarantees_card2_title": "Прозора історія",
    "landing.guarantees_card2_desc": "Кожна угода відображається в історії операцій зі статусом і датою.",
    "landing.guarantees_card3_title": "Швидке виведення",
    "landing.guarantees_card3_desc": "Зарахування на баланс одразу після продажу, виведення — від мінімальної суми протягом 24 годин.",
    "landing.guarantees_card4_title": "Двофакторний захист",
    "landing.guarantees_card4_desc": "Додатковий код підтвердження для входу та виведення коштів.",
    "landing.features_title": "Переваги",
    "landing.features_card1_title": "Надійні сценарії",
    "landing.features_card1_desc": "Зрозумілі статуси кожної операції",
    "landing.features_card2_title": "Швидкий доступ",
    "landing.features_card2_desc": "Колекції та активи без зайвих кроків",
    "landing.features_card3_title": "Чистий інтерфейс",
    "landing.features_card3_desc": "Дані та дії в центрі уваги",
    "landing.eyebrow": "Маркетплейс цифрових активів",
    "landing.auth_nav": "Навігація входу"
  },
  bl: {
    "landing.login": "Увайсці",
    "landing.signup": "Рэгістрацыя",
    "landing.hero_title": "Калекцыянуйце лічбавыя актывы ўпэўнена",
    "landing.hero_desc": "Адкрывайце калекцыі, кіруйце сваімі NFT і здзяйсняйце здзелкі ў адзіным празрыстым інтэрфейсе.",
    "landing.cta_start": "Пачаць працу",
    "landing.cta_have_account": "У мяне ёсць акаунт",
    "landing.how_title": "Як гэта працуе",
    "landing.how_step1_title": "Выберыце NFT",
    "landing.how_step1_desc": "Праглядайце калекцыі па сетцы, цане і статусе продажу.",
    "landing.how_step2_title": "Паповніце баланс",
    "landing.how_step2_desc": "Карта, СБП або крыптавалюта — баланс папаўняецца за некалькі клікаў.",
    "landing.how_step3_title": "Купляйце ў адзін клік",
    "landing.how_step3_desc": "Аплата спісваецца з балансу, NFT адразу з'яўляецца ў вашым партфелі.",
    "landing.how_step4_title": "Прадайце і вывядзіце",
    "landing.how_step4_desc": "Выставіце NFT на продаж і вывядзіце сродкі на працягу 24 гадзін.",
    "landing.guarantees_title": "Гарантыі",
    "landing.guarantees_card1_title": "Бяспечны баланс",
    "landing.guarantees_card1_desc": "Сродкі спісваюцца толькі пры пацвярджэнні пакупкі — памылковыя аперацыі выключаны.",
    "landing.guarantees_card2_title": "Празрыстая гісторыя",
    "landing.guarantees_card2_desc": "Кожная здзелка адлюстроўваецца ў гісторыі аперацый са статусам і датай.",
    "landing.guarantees_card3_title": "Хуткі вывад",
    "landing.guarantees_card3_desc": "Залічэнне на баланс адразу пасля продажу, вывад — ад мінімальнай сумы на працягу 24 гадзін.",
    "landing.guarantees_card4_title": "Двухфактарная абарона",
    "landing.guarantees_card4_desc": "Дадатковы код пацвярджэння для ўваходу і вываду сродкаў.",
    "landing.features_title": "Перавагі",
    "landing.features_card1_title": "Надзейныя сцэнарыі",
    "landing.features_card1_desc": "Зразумелыя статусы кожнай аперацыі",
    "landing.features_card2_title": "Хуткі доступ",
    "landing.features_card2_desc": "Калекцыі і актывы без лішніх крокаў",
    "landing.features_card3_title": "Чысты інтэрфейс",
    "landing.features_card3_desc": "Дадзеныя і дзеянні ў цэнтры ўвагі",
    "landing.eyebrow": "Маркетплейс лічбавых актываў",
    "landing.auth_nav": "Навігацыя ўваходу"
  },
  de: {
    "landing.login": "Anmelden",
    "landing.signup": "Registrieren",
    "landing.hero_title": "Sammeln Sie digitale Assets mit Zuversicht",
    "landing.hero_desc": "Entdecken Sie Kollektionen, verwalten Sie Ihre NFTs und handeln Sie in einer übersichtlichen Oberfläche.",
    "landing.cta_start": "Loslegen",
    "landing.cta_have_account": "Ich habe bereits ein Konto",
    "landing.how_title": "So funktioniert's",
    "landing.how_step1_title": "NFT auswählen",
    "landing.how_step1_desc": "Kollektionen nach Netzwerk, Preis und Verkaufsstatus durchsuchen.",
    "landing.how_step2_title": "Guthaben aufladen",
    "landing.how_step2_desc": "Karte, SBP oder Kryptowährung — Guthaben in wenigen Klicks aufladen.",
    "landing.how_step3_title": "Mit einem Klick kaufen",
    "landing.how_step3_desc": "Die Zahlung wird vom Guthaben abgebucht, das NFT erscheint sofort in Ihrem Portfolio.",
    "landing.how_step4_title": "Verkaufen und auszahlen",
    "landing.how_step4_desc": "NFT zum Verkauf anbieten und Guthaben innerhalb von 24 Stunden auszahlen.",
    "landing.guarantees_title": "Garantien",
    "landing.guarantees_card1_title": "Sicheres Guthaben",
    "landing.guarantees_card1_desc": "Beträge werden erst nach Bestätigung des Kaufs abgebucht — Fehlbuchungen sind ausgeschlossen.",
    "landing.guarantees_card2_title": "Transparente Historie",
    "landing.guarantees_card2_desc": "Jede Transaktion erscheint mit Status und Datum in der Historie.",
    "landing.guarantees_card3_title": "Schnelle Auszahlung",
    "landing.guarantees_card3_desc": "Gutschrift direkt nach dem Verkauf, Auszahlung ab dem Mindestbetrag innerhalb von 24 Stunden.",
    "landing.guarantees_card4_title": "Zwei-Faktor-Schutz",
    "landing.guarantees_card4_desc": "Zusätzlicher Bestätigungscode für Anmeldung und Auszahlungen.",
    "landing.features_title": "Vorteile",
    "landing.features_card1_title": "Verlässliche Abläufe",
    "landing.features_card1_desc": "Klarer Status für jede Operation",
    "landing.features_card2_title": "Schneller Zugriff",
    "landing.features_card2_desc": "Kollektionen und Assets ohne Umwege",
    "landing.features_card3_title": "Übersichtliche Oberfläche",
    "landing.features_card3_desc": "Daten und Aktionen im Mittelpunkt",
    "landing.eyebrow": "Marktplatz für digitale Assets",
    "landing.auth_nav": "Anmeldenavigation"
  },
  fr: {
    "landing.login": "Se connecter",
    "landing.signup": "S'inscrire",
    "landing.hero_title": "Collectionnez des actifs numériques en toute confiance",
    "landing.hero_desc": "Explorez des collections, gérez vos NFT et échangez dans une interface unique et transparente.",
    "landing.cta_start": "Commencer",
    "landing.cta_have_account": "J'ai déjà un compte",
    "landing.how_title": "Comment ça marche",
    "landing.how_step1_title": "Choisissez un NFT",
    "landing.how_step1_desc": "Parcourez les collections par réseau, prix et statut de vente.",
    "landing.how_step2_title": "Alimentez votre solde",
    "landing.how_step2_desc": "Carte, SBP ou crypto — rechargez votre solde en quelques clics.",
    "landing.how_step3_title": "Achetez en un clic",
    "landing.how_step3_desc": "Le paiement est débité du solde, le NFT apparaît aussitôt dans votre portefeuille.",
    "landing.how_step4_title": "Vendez et retirez",
    "landing.how_step4_desc": "Mettez un NFT en vente et retirez les fonds sous 24 heures.",
    "landing.guarantees_title": "Garanties",
    "landing.guarantees_card1_title": "Solde sécurisé",
    "landing.guarantees_card1_desc": "Les fonds ne sont débités qu'après confirmation de l'achat — aucune erreur de débit possible.",
    "landing.guarantees_card2_title": "Historique transparent",
    "landing.guarantees_card2_desc": "Chaque transaction apparaît dans l'historique avec son statut et sa date.",
    "landing.guarantees_card3_title": "Retraits rapides",
    "landing.guarantees_card3_desc": "Crédité sur le solde juste après la vente, retrait à partir du montant minimum sous 24 heures.",
    "landing.guarantees_card4_title": "Protection à deux facteurs",
    "landing.guarantees_card4_desc": "Un code de confirmation supplémentaire pour la connexion et les retraits.",
    "landing.features_title": "Atouts",
    "landing.features_card1_title": "Parcours fiables",
    "landing.features_card1_desc": "Statut clair pour chaque opération",
    "landing.features_card2_title": "Accès rapide",
    "landing.features_card2_desc": "Collections et actifs sans étapes superflues",
    "landing.features_card3_title": "Interface épurée",
    "landing.features_card3_desc": "Données et actions mises en avant",
    "landing.eyebrow": "Place de marché d'actifs numériques",
    "landing.auth_nav": "Navigation de connexion"
  },
  cn: {
    "landing.login": "登录",
    "landing.signup": "注册",
    "landing.hero_title": "自信收藏数字资产",
    "landing.hero_desc": "浏览收藏系列，管理您的NFT，并在统一透明的界面中完成交易。",
    "landing.cta_start": "开始使用",
    "landing.cta_have_account": "我已有账户",
    "landing.how_title": "使用流程",
    "landing.how_step1_title": "选择NFT",
    "landing.how_step1_desc": "按网络、价格和销售状态浏览收藏系列。",
    "landing.how_step2_title": "充值余额",
    "landing.how_step2_desc": "银行卡、SBP或加密货币 — 几步即可充值。",
    "landing.how_step3_title": "一键购买",
    "landing.how_step3_desc": "付款从余额扣除，NFT立即出现在您的作品集中。",
    "landing.how_step4_title": "出售并提现",
    "landing.how_step4_desc": "将NFT挂牌出售，24小时内提现资金。",
    "landing.guarantees_title": "保障",
    "landing.guarantees_card1_title": "安全的余额",
    "landing.guarantees_card1_desc": "仅在确认购买后才会扣款 — 杜绝错误扣费。",
    "landing.guarantees_card2_title": "透明的记录",
    "landing.guarantees_card2_desc": "每笔交易都会在操作记录中显示状态和日期。",
    "landing.guarantees_card3_title": "快速提现",
    "landing.guarantees_card3_desc": "出售后立即到账，最低金额起24小时内提现。",
    "landing.guarantees_card4_title": "双重身份验证",
    "landing.guarantees_card4_desc": "登录和提现需要额外的确认码。",
    "landing.features_title": "优势",
    "landing.features_card1_title": "可靠流程",
    "landing.features_card1_desc": "每笔操作状态清晰",
    "landing.features_card2_title": "快速访问",
    "landing.features_card2_desc": "收藏和资产无需多余步骤",
    "landing.features_card3_title": "简洁界面",
    "landing.features_card3_desc": "数据与操作一目了然",
    "landing.eyebrow": "数字资产交易市场",
    "landing.auth_nav": "登录导航"
  }
});
